import { P as PassageRouterView, R as RegisterRoute, u as useCallbacks, a as useRouter } from "../customElements.es2.js";
import { d as defineComponent, a as appStyles, o as onBeforeUpdate, u as useWebFonts, r as ref, b as useIntlTelInput, _ as _export_sfc, c as useAppId, s as setLocale, e as resolveComponent, f as createElementBlock, g as createBaseVNode, h as createBlock, i as useDefaultCountryCode, j as openBlock, k as defineCustomElement, l as safelyRegisterElement } from "../customElements.es.js";
const _sfc_main = defineComponent({
  name: "RegisterApp",
  props: {
    appId: String,
    beforeAuth: Function,
    onSuccess: Function,
    lang: String,
    defaultCountryCode: String
  },
  components: {
    PassageRouterView
  },
  styles: [appStyles],
  setup(props) {
    function storeProps() {
      const { updateAppId } = useAppId();
      if (props.appId) {
        updateAppId(props.appId);
      }
      const { updateDefaultCountryCode } = useDefaultCountryCode();
      updateDefaultCountryCode(props.defaultCountryCode);
      const { setBeforeAuth, setOnSuccess } = useCallbacks();
      setBeforeAuth(props.beforeAuth);
      setOnSuccess(props.onSuccess);
      setLocale(props.lang);
    }
    storeProps();
    onBeforeUpdate(() => {
      storeProps();
    });
    const { router } = useRouter();
    router.resetRouter();
    router.homeRoute = RegisterRoute;
    useWebFonts();
    const containerRef = ref();
    useIntlTelInput(containerRef);
    return {
      containerRef
    };
  }
});
const _hoisted_1 = {
  id: "passage-auth-container",
  ref: "containerRef"
};
const _hoisted_2 = { class: "container" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_passage_router_view = resolveComponent("passage-router-view");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createBaseVNode("div", _hoisted_2, [
      (openBlock(), createBlock(_component_passage_router_view, { key: _ctx.appId }))
    ])
  ], 512);
}
var RegisterApp = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
const PassageRegister = defineCustomElement(RegisterApp);
function registerPassageRegisterElement() {
  safelyRegisterElement(PassageRegister, "register");
}
registerPassageRegisterElement();
export { registerPassageRegisterElement };
